import { apiClient } from './client';

/**
 * Dispara la descarga de un endpoint del API que devuelve un blob.
 *
 * Por que no usar <a href> ni window.open:
 *   El access token vive en memoria (no en cookie), asi que el navegador
 *   no lo incluye en navegaciones nativas. apiClient.get con el interceptor
 *   si lo agrega como Authorization: Bearer y refresca si esta por expirar.
 */
export async function downloadBlob(
  url: string,
  filename: string,
  params?: Record<string, string | number | boolean | undefined>,
): Promise<void> {
  const cleanParams = params
    ? Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
    : undefined;

  const res = await apiClient.get<Blob>(url, {
    params: cleanParams,
    responseType: 'blob',
  });

  const objectUrl = URL.createObjectURL(res.data);
  try {
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }
}
